<template>
  <!-- 查看详情页面 -->
  <div class="details" :id="id" :arr="arr">
    <div class="back" @click="backEvent">{{ back }}{{ newsList }}</div>
    <div class="det">
      <div class="det_title">{{ newsDetails.title }}</div>
      <div class="det_time">{{ newsDetails.createData }}</div>
      <el-divider></el-divider>
      <div class="det_img">
        <img :src="newsDetails.url" alt="" style="width: 100%" />
      </div>
      <div class="det_cont" v-html="newsDetails.content"></div>
    </div>
    <el-divider></el-divider>
    <div class="next">
      <p @click="lastEvent">上一条内容</p>
      <p @click="nextEvent">下一条内容</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: "",
    },
    arr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      back: "<返回列表",
      newsDetails: {},
      flag: false,
      nowId: this.id,
    };
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    backEvent() {
      this.$emit("func", this.flag);
    },
    // 详情
    getDetails() {
      this.$axios
        .get("/content/content/getContentInfo/" + this.id)
        .then((res) => {
          console.log(res);
          this.newsDetails = res.data;
        });
    },
    // 上一个
    lastEvent() {
      for (let i in this.arr) {
        if (this.nowId == this.arr[i].id) {
          if (i == 0) {
            this.$message({
              type: "warning ",
              message: "已经是第一条案例了",
            });
          } else {
            let id = this.arr[i - 1].id;
            console.log(id);
            this.$axios
              .get("/content/content/getContentInfo/" + id)
              .then((res) => {
                console.log(res);
                this.newsDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
    // 下一个
    nextEvent() {
      for (let i in this.arr) {
        if (this.nowId == this.arr[i].id) {
          if (i == this.arr.length - 1) {
            this.$message({
              type: "warning ",
              message: "已经是最后一条案例了",
            });
          } else {
            let index = Number(i) + 1;
            let id = this.arr[index].id;
            console.log(id);
            this.$axios
              .get("/content/content/getContentInfo/" + id)
              .then((res) => {
                console.log(res);
                this.newsDetails = res.data;
                this.nowId = res.data.id;
              });
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  width: 100%;
  background: #ffffff;
  box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
  text-align: left;
  .back {
    margin: 20px 20px 0;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3660d9;
    line-height: 48px;
    opacity: 0.8;
  }
  .det {
    margin: 20px 28px;
    .det_cont {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #808080;
      line-height: 36px;
      text-indent: 2em;
    }
    .det_title {
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2f2f2f;
      line-height: 48px;
      text-align: center;
    }
    .det_time {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #808080;
      line-height: 36px;
      opacity: 0.8;
      text-align: center;
    }
    .det_img {
      display: flex;
      justify-content: space-between;
      margin: 40px 0;
    }
  }
}
.next {
  padding: 10px;
  text-align: left;
  color: rgb(53, 128, 241);
  p {
    margin: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newsCenter/details.vue